import React from "react";
import Home from "./Home";
import Particle from "./components/particles/Particle";

function App() {
  return (
    <div className="w-full lgl:h-screen font-bodyfont overflow-hidden text-textColor bg-black relative">
      <div className="max-w-screen-2xl h-full mx-auto flex justify-center items-center">
        <Home />
      </div>
      <div className="w-full h-full absolute top-0 left-0 z-10">
        <Particle />
      </div>
    </div>
  );
}

export default App;
